import React, { useState } from "react";
import { ControlBar, Player, PlaybackRateMenuButton } from "video-react";
import { SvgIcon } from "@mui/material";

import { HomeConfig } from "config/homeConfig";
import { VideoWrapper } from "./styled";

import "video-react/dist/video-react.css";
let playerRef;

export default function Video({ showControls = false, title, video, poster }) {
  const [isMuted, setVideoAction] = useState(false);
  const handleVideoAction = () => {
    if (isMuted) {
      playerRef.muted = true;
    } else {
      playerRef.muted = false;
    }
    setVideoAction(!isMuted);
  };

  const wrapperClassName = showControls ? "show-control" : "hide-control";
  return (
    <VideoWrapper>
      <div className={wrapperClassName + " video-wrapper"}>
        {title ? <div className="title">{title}</div> : null}
        <Player
          ref={(_player) => {
            playerRef = _player;
          }}
          // autoPlay
          playsInline
          loop
          // muted
          poster={poster}
          src={video}
        >
          {showControls ? (
            <ControlBar>
              <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} />
            </ControlBar>
          ) : null}
        </Player>

        {showControls ? null : (
          <div className="icon-wrapper">
            <SvgIcon
              sx={{ background: "white", borderRadius: "50%", padding: "5px" }}
              fontSize="large"
              onClick={handleVideoAction}
            >
              {isMuted
                ? HomeConfig.contentInfo.icon.soundon
                : HomeConfig.contentInfo.icon.soundoff}
            </SvgIcon>
          </div>
        )}
      </div>
    </VideoWrapper>
  );
}
